/**
 * Coaching requests (client) – create request to a coach.
 */
import { collection, addDoc, deleteDoc, doc, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'coachingRequests';

export function coachingRequestRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();
  const coll = () => collection(firestore, COLLECTION);

  return {
    async create(data) {
      const ref = await addDoc(coll(), {
        ...data,
        status: 'pending',
        createdAt: new Date(),
      });
      return ref.id;
    },

    async getExisting(clientId, coachId) {
      const q = query(
        coll(),
        where('clientId', '==', clientId),
        where('coachId', '==', coachId),
        limit(1)
      );
      const snap = await getDocs(q);
      if (snap.empty) return null;
      const d = snap.docs[0];
      return { id: d.id, ...d.data() };
    },

    async listByClient(clientId, limitCount = 50) {
      const q = query(
        coll(),
        where('clientId', '==', clientId),
        orderBy('createdAt', 'desc'),
        limit(limitCount)
      );
      const snap = await getDocs(q);
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    },

    async cancel(requestId) {
      await deleteDoc(doc(firestore, COLLECTION, requestId));
    },
  };
}

export const coachingRequestRepo = coachingRequestRepository();
